import { create } from 'zustand'

type ActionDialogType = 'action' | 'danger' | 'manual'

type ActionDialogProps = {
  title: React.ReactNode | string
  type: ActionDialogType
  ctaText: string
  content: React.ReactNode
  withCancelButton?: boolean
}

type ActionDialogActions = {
  openDialog: (
    props: ActionDialogProps,
    callback: (doAction: boolean, e?: React.FormEvent<HTMLFormElement>) => Promise<boolean | void>, // if true, failed
  ) => void
  clearDialog: () => void
}

type ActionDialogState = {
  title: React.ReactNode | string
  content: React.ReactNode
  type: ActionDialogType
  ctaText: string
  withCancelButton?: boolean
  callback?: (doAction: boolean, e?: React.FormEvent<HTMLFormElement>) => Promise<boolean | void>
  actions: ActionDialogActions
}

const DEFAULT_STATE: Omit<ActionDialogState, 'actions'> = {
  title: '',
  content: null,
  type: 'action' as ActionDialogType,
  ctaText: '',
  callback: undefined,
  withCancelButton: true,
}

const useActionDialogStore = create<ActionDialogState>((set) => ({
  ...DEFAULT_STATE,
  actions: {
    clearDialog: () => set({ ...DEFAULT_STATE }),
    openDialog: (props, callback) => {
      set({
        ...props,
        callback,
      })
    },
  },
}))

export default useActionDialogStore
